module.exports = __webpack_public_path__ + "23_tvcg.jpg?d180e9f29c307da4810fa596f7843f8f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_tvcg.jpg
// module id = 206
// module chunks = 0